<template>
  <div v-if="!isLoadingCertificate" class="container">
    <certificate-waiting v-if="currentCertificate.in_process"></certificate-waiting>
    <div id="sertifikat-regular-page" v-else>
      <div id="header-mobile-version">
        <header-mobile />
      </div>
      <img
        v-for="(certificate, indexCertificate) in currentCertificate.url_image"
        :key="indexCertificate"
        :src="certificate"
        :alt="`sertifikat+${indexCertificate}`"
        class="certificate-image"
      />
      <div id="footer-wrapper" style="width: 100%">
        <div id="desktop-footer">
          <download-area />
        </div>
        <div id="footer-mobile-version">
          <footer-mobile />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <Loading />
  </div>
</template>

<script>

import DownloadArea from '@/views/sertifikat/DownloadSertifikat.vue'
import CertificateWaiting from '@/views/sertifikat/CertificateWaiting.vue'
import HeaderMobile from '@/components/sertifikat/HeaderMobile.vue'
import FooterMobile from '@/components/sertifikat/FooterMobile.vue'
import Loading from '@/components/Loading.vue'

export default {
  name: 'ProgramCertificate',
  components: {
    DownloadArea,
    CertificateWaiting,
    HeaderMobile,
    FooterMobile,
    Loading
  },
  data: () => ({
    isLoadingCertificate: false
  }),
  computed: {
    currentCertificate: {
      get () {
        return this.$store.state.certificate.currentCertificate
      },
      set (value) {
        this.$store.commit('certificate/CHANGE_CURRENT_CERTIFICATE', value)
      }
    }
  },
  methods: {
    async fetchSertifikat () {
      try {
        this.isLoadingCertificate = true
        const certificateId = isNaN(this.$route.params.id) ? this.$route.params.id : window.btoa(`program_user-${this.$route.params.id}`)
        const certificateType = this.$route.query.type === 'addon' ? 'addon' : 'regular'

        const { data } = await this.$axiosServer({
          url: `/program_activity/v2/certificate/${certificateType}/${certificateId}`,
          method: 'post',
          headers: {
            Authorization: this.accessToken || process.env.VUE_APP_APP_KEY
          },
          generateQueryParamSource: true
        })
        if (data.status === 200) {
          this.currentCertificate = data.data
        } else {
          throw data
        }
      } catch (err) {
        console.error(err)
        this.$router.push('/')
      } finally { this.isLoadingCertificate = false }
    }
  },
  created () {
    this.fetchSertifikat()
  },
  head: {
    title: 'Sertifikat | Karier.mu'
  }
}
</script>

<style scoped>
.certificate-image {
  max-width: 100%;
  margin-bottom: 36px;
  margin-top: 36px;
}

#header-mobile-version {
  display: none;
}

#footer-mobile-version {
  display: none;
}

p {
  margin-bottom: 0px;
}

#sertifikat-regular-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-background {
  width: 1110px;
  height: 740px;
  position: relative;
}

.content-wrapper {
  position: absolute;
  width: 100%;
}

.content-inside {
  position: absolute;
  width: 100%;
  top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.certificate-number {
  display: flex;
  justify-content: flex-end;
  width: 1110px;
  padding: 5px 50px;
}

.value-certificate-number {
  font-family: Roboto;
  color: white;
}

.content-certificate {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px;
}

#logo-sekolahmu {
  width: 300px;
}

.certificate-present {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0px;
}

.present-id {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  color: #333333;
}

.present-en {
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
}

.certificate-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px;
}

.title-id {
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  text-transform: uppercase;
  line-height: 45px;
  color: #1a2e5a;
}

.title-en {
  font-style: italic;
  font-weight: bold;
  font-size: 14px;
  text-transform: lowercase;
  color: #1a2e5a;
}

.certificate-owner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.owner-id {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
}

.owner-en {
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
}

.name-id {
  /* font-family: Catalunya demo; */
  font-style: normal;
  font-weight: normal;
  font-size: 45px;
  text-align: center;
  color: #333333;
}

.certificate-congrats {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0px;
}

.congrats-id {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
}

.congrats-en {
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
}

.certificate-program-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0px;
}

.program-title-id {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}

.program-title-en {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #000000;
}

.signature-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.certificate-date {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #333333;
}

#signature-image {
  width: 100px;
}

.certificate-head {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.head-id {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #333333;
}

.head-en {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #333333;
}

.print-button {
  display: flex;
  align-items: center;
  background: #fec203;
  border-radius: 18px;
  padding: 5px 20px;
  border: 1px solid #fec203;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  margin: 10px 0px;
}

#image-print {
  width: 30px;
}

#print-wrapper {
  margin-bottom: 50px;
}

@media screen and (max-width: 1110px) {
  #sertifikat-regular-page {
    width: 100%;
  }

  .image-background {
    width: 100%;
    object-fit: contain;
  }

  .content-wrapper {
    object-fit: contain;
  }

  .certificate-number {
    width: 100%;
    padding: 0px 50px;
  }

  .content-certificate {
    padding: 0px;
  }
}

@media screen and (max-width: 980px) {
  #logo-sekolahmu {
    width: 250px;
  }

  .present-id {
    font-size: 14px;
  }

  .present-en {
    font-size: 11px;
  }

  .title-id {
    font-size: 40px;
  }

  .owner-id {
    font-size: 14px;
  }

  .congrats-id {
    font-size: 15px;
  }

  .congrats-en {
    font-size: 11px;
  }

  .program-title-id {
    font-size: 22px;
  }

  .program-title-en {
    font-size: 16px;
  }

  .certificate-date {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .image-background {
    height: 550px;
  }

  .content-inside {
    top: 30px;
  }

  .certificate-number {
    padding: 0px 30px;
    font-size: 14px;
  }

  #logo-sekolahmu {
    width: 200px;
  }

  .present-id {
    font-size: 12px;
  }

  .present-en {
    font-size: 10px;
  }

  .certificate-title {
    padding: 5px 0px;
  }

  .title-id {
    font-size: 30px;
    line-height: 30px;
  }

  .title-en {
    font-size: 12px;
  }

  .owner-id {
    font-size: 12px;
  }

  .owner-en {
    font-size: 10px;
  }

  .name-id {
    font-size: 30px;
  }

  .certificate-congrats {
    padding: 2px 0px;
  }

  .congrats-id {
    font-size: 12px;
  }

  .congrats-en {
    font-size: 10px;
  }

  .certificate-program-title {
    padding: 2px 0px;
  }

  .program-title-id {
    font-size: 20px;
  }

  .program-title-en {
    font-size: 14px;
  }

  .certificate-date {
    font-size: 12px;
  }

  #signature-image {
    width: 75px;
  }

  .head-id {
    font-size: 13px;
  }

  .head-en {
    font-size: 12px;
  }
}

@media screen and (max-width: 425px) {
  #header-mobile-version {
    display: flex;
  }

  #footer-mobile-version {
    display: flex;
  }

  #desktop-footer {
    display: none;
  }

  #sertifikat-regular-page {
    padding: 20px;
  }

  .image-background {
    height: 275px;
  }

  .print-button {
    font-size: 12px;
    padding: 2px 15px;
  }

  .content-inside {
    top: 355px;
  }

  .certificate-number {
    padding: 0px 40px;
    font-size: 8px;
  }

  #logo-sekolahmu {
    width: 100px;
  }

  .certificate-present {
    padding: 2px 0px;
  }

  .present-id {
    font-size: 6px;
  }

  .present-en {
    font-size: 5px;
  }

  .certificate-title {
    padding: 2px 0px;
  }

  .title-id {
    font-size: 14px;
    line-height: 14px;
  }

  .title-en {
    font-size: 7px;
  }

  .owner-id {
    font-size: 6px;
  }

  .owner-en {
    font-size: 5px;
  }

  .name-id {
    font-size: 15px;
  }

  .congrats-id {
    font-size: 7px;
  }

  .congrats-en {
    font-size: 5px;
  }

  .certificate-program-title {
    padding: 0px;
  }

  .program-title-id {
    font-size: 10px;
  }

  .program-title-en {
    font-size: 8px;
  }

  .certificate-date {
    font-size: 8px;
  }

  #signature-image {
    width: 30px;
  }

  .head-id {
    font-size: 7px;
  }

  .head-en {
    font-size: 6px;
  }
}

@media screen and (max-width: 375px) {
  #sertifikat-regular-page {
    padding: 15px;
  }

  .image-background {
    height: 250px;
  }

  .print-button {
    font-size: 10px;
    padding: 2px 15px;
  }

  #image-print {
    width: 20px;
  }

  .content-inside {
    top: 355px;
  }

  .certificate-number {
    padding: 0px 30px;
    font-size: 7px;
  }

  #logo-sekolahmu {
    width: 100px;
  }

  .certificate-present {
    padding: 1px 0px;
  }

  .present-id {
    font-size: 6px;
  }

  .present-en {
    font-size: 4px;
  }

  .certificate-title {
    padding: 1px 0px;
  }

  .title-id {
    font-size: 12px;
    line-height: 12px;
  }

  .title-en {
    font-size: 6px;
  }

  .owner-id {
    font-size: 4px;
  }

  .owner-en {
    font-size: 4px;
  }

  .name-id {
    font-size: 12px;
  }

  .certificate-congrats {
    padding: 3px 0px 2px 0px;
  }

  .congrats-id {
    font-size: 5px;
  }

  .congrats-en {
    font-size: 4px;
  }

  .certificate-program-title {
    padding: 0px;
  }

  .program-title-id {
    font-size: 8px;
  }

  .program-title-en {
    font-size: 7px;
  }

  .certificate-date {
    font-size: 6px;
  }

  #signature-image {
    width: 30px;
  }

  .head-id {
    font-size: 7px;
  }

  .head-en {
    font-size: 6px;
  }
}

@media screen and (max-width: 320px) {
  #sertifikat-regular-page {
    padding: 10px;
  }

  .image-background {
    height: 225px;
  }

  .print-button {
    font-size: 8px;
    padding: 1px 15px;
  }

  #image-print {
    width: 15px;
  }

  .content-inside {
    top: 353px;
  }

  .certificate-number {
    padding: 0px 25px;
    font-size: 6px;
  }

  #logo-sekolahmu {
    width: 85px;
  }

  .certificate-present {
    padding: 1px 0px;
  }

  .present-id {
    font-size: 4px;
  }

  .present-en {
    font-size: 3px;
  }

  .certificate-title {
    padding: 2px 0px;
  }

  .title-id {
    font-size: 10px;
    line-height: 10px;
  }

  .title-en {
    font-size: 5px;
  }

  .owner-id {
    font-size: 4px;
  }

  .owner-en {
    font-size: 3px;
  }

  .name-id {
    font-size: 10px;
  }

  .certificate-congrats {
    padding: 3px 0px 2px 0px;
  }

  .congrats-id {
    font-size: 5px;
  }

  .congrats-en {
    font-size: 4px;
  }

  .certificate-program-title {
    padding: 0px;
  }

  .program-title-id {
    font-size: 7px;
  }

  .program-title-en {
    font-size: 6px;
  }

  .certificate-date {
    font-size: 6px;
  }

  #signature-image {
    width: 25px;
  }

  .head-id {
    font-size: 5px;
  }

  .head-en {
    font-size: 4px;
  }
}

@media print {
  @page {
    size: A4 landscape;
  }
}
</style>
